<template>
    <transition name="toolbar-slide">
        <div v-if="isToolbarVisible" class="activities-toolbar-container">
            <div class="activities-toolbar">
                <span class="typographies-paragraph-medium-bold btn-cancel-selected-items">
                    <CompassIconButton icon="close" variant="contrast" @click="closeToolbar" />
                    {{ selectedActivitiesCount }}
                    {{
                        selectedActivitiesCount === 1
                            ? $t.__('common.labels.selected_singular')
                            : $t.__('common.labels.selected_plural')
                    }}
                </span>
                <CompassButton
                    :label="$t.__('common.actions.finish')"
                    type="tertiary-contrast"
                    leftIcon="success"
                    @click="handleOpenMarkAssDone"
                />
                <CompassButton
                    :label="$t.__('common.actions.reschedule')"
                    type="tertiary-contrast"
                    leftIcon="calendar-reschedule"
                    @click="handleRescheduleModal"
                />
                <CompassButton
                    :label="
                        $t.__(
                            'activities.listing.massActions.ActivitiesListingMassActions.modify_owner',
                        )
                    "
                    type="tertiary-contrast"
                    leftIcon="user-fill"
                    @click="handleAssignOwnerModal"
                />
                <CompassTooltip
                    :disabled="!areOnlyPhonecallsSelected"
                    :content="
                        $t.__(
                            'activities.listing.massActions.ActivitiesListingMassActions.tooltip_disabled_assign_button',
                        )
                    "
                    placement="top"
                >
                    <CompassButton
                        :label="$t.__('common.actions.assign')"
                        type="tertiary-contrast"
                        leftIcon="user-fill"
                        :disabled="areOnlyPhonecallsSelected"
                        @click="handleAssignModal"
                    />
                </CompassTooltip>
                <CompassButton
                    :label="$t.__('common.actions.delete')"
                    type="tertiary-contrast"
                    leftIcon="bin"
                    @click="handleDeleteModal"
                />
            </div>
        </div>
    </transition>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapPopupPanelActions } = createNamespacedHelpers('popupPanel');
const { mapState: mapSystemState } = createNamespacedHelpers('system');
export default {
    props: {
        selectedActivities: {
            type: Array,
            default: () => [],
        },
        isToolbarVisible: {
            type: Boolean,
        },
        workingDays: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isRescheduleModalVisible: false,
        };
    },
    computed: {
        ...mapSystemState(['errorsHandler']),
        selectedActivitiesCount() {
            return this.selectedActivities.length;
        },
        areOnlyPhonecallsSelected() {
            return this.selectedActivities.every((activity) => activity.type === 'phonecall');
        },
    },
    methods: {
        ...mapPopupPanelActions(['open']),
        handleDeleteModal() {
            this.open({
                key: 'activitiesListingMassDelete',
                props: {
                    selectedActivities: this.selectedActivities,
                    onSuccess: this.handleSuccess,
                    onError: this.handleError,
                },
            });
        },
        handleRescheduleModal() {
            this.open({
                key: 'activitiesListingMassReschedule',
                props: {
                    selectedActivities: this.selectedActivities,
                    workingDays: this.workingDays,
                    onSuccess: this.handleSuccess,
                    onError: this.handleError,
                },
            });
        },
        handleOpenMarkAssDone() {
            this.open({
                key: 'activitiesMassMarkAsDone',
                props: {
                    selectedActivities: this.selectedActivities,
                    onSuccess: this.handleSuccess,
                    onError: this.handleError,
                },
            });
        },
        handleAssignOwnerModal() {
            this.open({
                key: 'activitiesListingMassModifyOwner',
                props: {
                    selectedActivities: this.selectedActivities,
                    onSuccess: this.handleSuccess,
                    onError: this.handleError,
                },
            });
        },
        handleAssignModal() {
            this.open({
                key: 'activitiesListingMassAssign',
                props: {
                    selectedActivities: this.selectedActivities,
                    onSuccess: this.handleSuccess,
                    onError: this.handleError,
                },
            });
        },
        closeToolbar() {
            this.$emit('closeToolbar');
        },
        handleSuccess() {
            this.$pushToast({
                type: 'success',
                text: this.$t.__(
                    'activities.listing.massActions.ActivitiesListingMassActions.successToast',
                ),
                icon: true,
                close: true,
            });
            this.closeToolbar();
            this.$trigger('activities-listing-table:refresh');
        },
        handleError(error = null) {
            if (error) {
                this.errorsHandler.logException(error);
            }
            this.$pushToast({
                type: 'error',
                text: this.$t.__(
                    'activities.listing.massActions.ActivitiesListingMassActions.errorToast',
                ),
                icon: true,
                close: true,
            });
        },
    },
};
</script>

<style scoped lang="scss">
.toolbar-slide-enter-active,
.toolbar-slide-leave-active {
    transition: transform 0.3s ease;
}

.toolbar-slide-enter,
.toolbar-slide-leave-to {
    transform: translateY(110px);
}

.toolbar-slide-enter-to,
.toolbar-slide-leave {
    transform: translateY(0);
}

.activities-toolbar-container {
    position: fixed;
    left: 184px;
    right: 120px;
    bottom: 40px;
    z-index: 2;
}

.activities-toolbar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-radius: var(--spacing-0);
    padding: var(--spacing-3) var(--spacing-4);
    gap: var(--spacing-3);
    color: var(--colors-common-text-standard-on-color);
    background-color: var(--colors-common-border-primary-hover);
}

.btn-cancel-selected-items {
    display: flex;
    align-items: center;
    gap: var(--spacing-0);
    padding-right: var(--spacing-4);
    border-right: 1px solid var(--colors-common-border-lighter);
}
</style>
